import { createContext, useContext, type ComponentPropsWithoutRef } from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';

type SliderRootProps = ComponentPropsWithoutRef<typeof SliderPrimitive.Root>;

export type SliderContextValue = Required<
  Pick<SliderRootProps, 'min' | 'max' | 'step' | 'minStepsBetweenThumbs'>
> &
  Pick<SliderRootProps, 'disabled'> & {
    values: number[];
    onValueChange: NonNullable<SliderRootProps['onValueChange']>;
    onValueCommit?: SliderRootProps['onValueCommit'];
  };

const SliderContext = createContext<SliderContextValue | undefined>(undefined);

export const SliderProvider = SliderContext.Provider;

// Returns the slider context, or `undefined` when used outside a `<SliderField>`.
// (needed when using standalone Slider)
export const useSliderContext = () => useContext(SliderContext);

// Like `useSliderContext` but throws — for components that require a `<SliderField>`.
// (needed for SliderInputs)
export const useRequiredSliderContext = () => {
  const context = useSliderContext();
  if (!context) {
    throw new Error(`Component must be rendered within a <SliderField>.`);
  }
  return context;
};
